import React from 'react';

const TypeThreeText = () => {
  return <div>SMS, 이메일을 통해 이용권 및 이벤트 정보를 받아보실 수 있습니다.</div>;
};

export default TypeThreeText;
